<!--
 * @Description:
 * @Author: hanyu
 * @Date: 2020-01-20 09:38:08
 * @LastEditTime: 2021-01-19 17:08:30
 * @LastEditors: hanyu
 -->
<template>
  <Page ref="pages"
        :size="size"
        :current="pageNum"
        :page-size="pageSize"
        :total="pageTotal"
        transfer
        :show-sizer="showSizer"
        :page-size-opts="PAGE_SIZE_OPTIONS"
        show-total
        @on-change="changePage"
        @on-page-size-change="changePageSize"></Page>
</template>

<script>
/**
 * 分页组件
 * 示例参数
 * pageInfo:{
        pageNum: 1, // 当前页数
        pageSize: 10, // 当前页面展示条数
        pageTotal: 20 // 数据总条数
 * }
 */
import { PAGE_SIZE_OPTIONS } from '@/constant/pagination.js';

export default {
  // 接收参数
  props: {
    // 是否显示分页
    showSizer: {
      type: Boolean,
      default: true
    },
    size: {
      type: String,
      default: 'small'
    },
    // 分页数据
    pageInfo: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  data () {
    return {
      PAGE_SIZE_OPTIONS,
      pageNum: this.pageInfo.pageNum,
      pageSize: this.pageInfo.pageSize,
      pageTotal: this.pageInfo.pageTotal
    };
  },
  watch: {
    pageInfo: {
      // 监听总条数，计算当前是第几页，返回事件
      handler (val) { // 特别注意，不能用箭头函数，箭头函数，this指向全局
        this.pageNum = val.pageNum;
        this.pageSize = val.pageSize;
        this.pageTotal = val.pageTotal;
      },
      deep: true // 深度监听
    }
  },
  // 方法集合
  methods: {
    changePageSize (e) {
      this.pageSize = e;
      this.pageNum = 1;
      this.$emit('change', {
        pageNum: 1,
        pageSize: e,
        pageTotal: this.pageTotal
      });
    },
    // 分页改变
    changePage (e) {
      this.pageNum = e;
      this.$emit('change', {
        pageNum: e,
        pageSize: this.pageSize,
        pageTotal: this.pageTotal
      });
    }
  }
};
</script>
<style lang='less' scoped>
/deep/ .ivu-page-total {
  color: #999999;
}

/deep/ .ivu-select-selected-value {
  color: #999999;
}

/deep/ .ivu-icon-ios-arrow-down {
  color: #999999;
}
</style>
